import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';

import {aiAssistantContextStore} from '@dms/ai-assistant';
import {getRouteParams} from '@dms/routes';

/**
 * Keeps the store's `location` (path + route params + URL search params) in step with the URL bar.
 * A router location change fits none of the 5 approved no-useEffect patterns. This named effect is
 * keyed on pathname + search and updates subscribed assistant consumers through `patchContext`.
 */
export function AiAssistantLocationSync(): null {
  const location = useLocation();

  useEffect(
    function syncLocationToAssistantContext() {
      aiAssistantContextStore.patchContext({
        location: {
          path: location.pathname,
          query: getRouteParams(location.pathname),
          search: Object.fromEntries(new URLSearchParams(location.search)),
        },
      });
    },
    [location.pathname, location.search]
  );

  return null;
}
